<template>
  <div>
    <b-navbar sticky="true" type="light" variant="light">
		<div class="container">
			<b-navbar-brand to="/flat-design">扁平化设计</b-navbar-brand>
			<b-navbar-nav class="ml-auto" small="true" >
				<!-- <b-nav-item to="#">概览</b-nav-item>
      			<b-nav-item to="#">如何使用</b-nav-item> -->
				<b-button rel="noopener" target="_blank" pill size="sm" variant="primary" @click="leaveFor" href="http://zhuti.xiaomi.com/detail/89b9e572-a721-4a04-a2e3-6c5ceb91f47c" >前往下载</b-button>
			</b-navbar-nav>
		</div>
    </b-navbar>

	<div class="card-container" >
    	<div class="card-content" >
			<div class="description-container" style="text-align: center;" >
			<div>
				<h1>扁平化设计</h1>
				<h3>美观与易用的完美结合</h3>
				<p>精致的设计要素，去繁就简而又舒适自然，让你专注内容并事事有序。
				</p>
			</div>
			</div>
			<div class="img-container" >
				<img src="@/assets/Mi_Theme/Flat_Design/tile.png" >
			</div>
	  	</div>
  	</div>

	<div class="card-container" >
      <div class="card-content" >
        <b-row no-gutters>
          <b-col sm="6">
            
            <div class="img-container" >
			  <img src="@/assets/Mi_Theme/Flat_Design/appose.png" >
            </div>
                
          </b-col>
          <b-col sm="6">
            
            <div class="description-container">
              <div>
                <h2>简洁，但却不简单</h2>
				<h3>更简单、更实用</h3>
				<p>这是一种妙趣横生用户体验，令功用性高于一切，而设计服务于体验。</p>
                </p>
              </div>
            </div>
            
          </b-col>
        </b-row>
      </div>
    </div>

  </div>
</template>

<style lang="stylus" scoped>
	@import '~@/components/OverviewCard.styl'
</style>

<script>
export default {
    methods: {
        leaveFor() {
            this.$ga.event('mi-theme', 'miStore', 'flat-design', 1)
            },
	},
}
</script>